import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Container, Typography, Select, MenuItem, FormControl, InputLabel, TextField } from "@mui/material";
import { editbankaccount } from "../../../components/Apis";
import Swal from "sweetalert2";

function EditPayment({  bankID, bank ,close ,render}) {
    // const [bankaccountID, setBankaccountID] = useState({ bankAccount });
    // const [bankaccountNum, setBankaccountNum] = useState({ bankAccount });

    const [Bank, setBank] = useState(bank);
    // console.log("popup bank ", bankAccount)
    const token = localStorage.getItem("token");

    const [formData, setFormData] = useState({
        account_number: "",
        bank_id: "",
    });


    // useEffect(() => {
    //     bankAccount.map((item) => {
    //         console.log("popup bank account", item.id)
    //         setBankaccountID(item.id)
    //         setBankaccountNum(item.account_number)
    //         // onChange(response.bank_id)

    //     })
    // }, [bankAccount])


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("on dfsdfhsdjfk", formData)
        const response = await editbankaccount(bankID, formData,)
        // console.log("Account changed:", response.bank_id);
        close();
        render();
        // window.location.reload();

    };



    const handleNumberChange = (event) => {
        setFormData({ ...formData, account_number: Number(event.target.value) });
    };
    const handleBankChange = (event) => {
        setFormData({ ...formData, bank_id: event.target.value });
    };

    return (
        <Container maxWidth="sm" dir="ltr" sx={{ 
            backgroundColor: "var(--seco-col)", 
            p: 3, 
            borderRadius: "10px", 
            border: "none !important", 
            boxShadow: "none",
            margin: { xs: '16px', sm: '24px', md: 'auto' },
            width: { xs: 'calc(100% - 32px)', sm: 'calc(100% - 48px)', md: 'auto' }

        }}>
            <Typography variant="h5" sx={{ mb: 2, textAlign: "center", fontWeight: "bold", color: "#333" }}>
                Edit Bank Account
            </Typography>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <TextField
                    name="account_number"
                    label="Account Number"
                    type="text"
                    //   value={bankaccountNum || ""}
                    onChange={handleNumberChange}
                    // fullWidth
                    sx={{ width: '100%', direction: "ltr" }}
                    margin="normal"
                />
                <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }}>
                    <InputLabel shrink={false} sx={{
                        position: 'relative',
                        transform: 'none',
                        marginBottom: '5px'
                    }}>Select Unit</InputLabel>
                    <Select
                        // value={formData.unit_id}
                        onChange={handleBankChange}
                        variant="outlined"
                        sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                    >
                        {bank.map((unit) => (
                            <MenuItem key={unit.id} value={unit.id} dir="ltr">
                                {unit.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }} dir="ltr">
                    <InputLabel shrink={false} sx={{
                        position: 'relative',
                        transform: 'none',
                        marginBottom: '5px'
                    }}> Select Service </InputLabel>
                    <Select
                        value={formData.service_id}
                        onChange={handleServiceChange}
                        variant="outlined"
                        sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                    >
                        {service.map((service) => (
                            <MenuItem key={service.id} value={service.id} dir="ltr">
                                {service.service}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl> */}

                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    sx={{
                        mt: 2,
                        padding: "10px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        backgroundColor: "var(--pri-col)",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "var(--pri-col)",
                            color: "white",
                        },
                    }}
                    disabled={!formData.bank_id}
                >
                    Submit
                </Button>
            </form>
        </Container>
    )
}

export default EditPayment
